module.exports = __webpack_public_path__ + "img/orange_005.99ba8b2f.png";